import { render, staticRenderFns } from "./BuyerRoi.vue?vue&type=template&id=2dc78a41&"
import script from "./BuyerRoi.vue?vue&type=script&lang=js&"
export * from "./BuyerRoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports